// @flow

import { getLibrary } from '../services/dipseaApi'
import type { TrackPropsType } from './Track'
import { convertTrackToProps, getCanonicalSlug, isValidTrack } from './Track'

export async function getAllTrackToActors (): Promise<string[][]> {
  const library = await getLibrary()
  const trackSlugs = Object.keys(library?.slugs?.tracks || {})
  const actorTracksSlugs = []
  trackSlugs.forEach((slug: string): void => {
    const trackId = library.slugs.tracks[slug]
    const track = library.tracks[trackId]

    if (track?.actors && getCanonicalSlug(track) === slug) {
      Object.keys(track?.actors || {}).forEach((actorId: string): void => {
        actorTracksSlugs.push([slug, actorId])
      })
    }
  })
  return actorTracksSlugs
}

export async function getActorTracks (actorId: string): Promise<TrackPropsType[]> {
  const library = await getLibrary()
  const actor = library?.actors[actorId]
  if (actor) {
    return Object.keys(actor.trackIds || {})
      .filter((key: string): boolean => isValidTrack(library.tracks[key]))
      .map((key: string): TrackPropsType => convertTrackToProps(library.tracks[key], library))
  }
  return []
}

export async function getAllCharacterToActors (): Promise<string[][]> {
  const library = await getLibrary()
  const contextSlugs = Object.keys(library?.slugs?.contexts || {})
  const actorCharacterSlugs = []
  contextSlugs.forEach((slug: string): void => {
    const catId = library.slugs.contexts[slug]
    const character = library.contexts[catId]

    if (character?.actors) {
      Object.keys(character?.actors || {}).forEach((actorId: string): void => {
        actorCharacterSlugs.push([slug, actorId])
      })
    }
  })
  return actorCharacterSlugs
}
